import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from './stateManagement/store';
import { clearToken } from './stateManagement/authSlice';
import { useSnackbar } from 'notistack';

const ProtectedRoutes: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => {
        // ✅ Success handler
        if (response.status >= 200 && response.status < 300) {
          if (response.config.method === 'post') {
            enqueueSnackbar('Saved successfully!', { variant: 'success' });
          }
          if (response.config.method === 'put') {
            enqueueSnackbar('Updated successfully!', { variant: 'success' });
          }
          if (response.config.method === 'delete') {
            enqueueSnackbar('Deleted / Restore successfully!', { variant: 'success' });
          }
        }
        return response;
      },
      (error) => {
        // ❌ Error handler
        const status = error.response ? error.response.status : null;
        const message =
          error.response?.data?.message || error.message || 'An unexpected error occurred.';

        if (status === 401) {
          dispatch(clearToken());
          navigate('/login');
        }

        enqueueSnackbar(message, { variant: 'error' });

        return Promise.reject(error);
      }
    );

    // Cleanup to avoid multiple interceptors being added
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate, dispatch, enqueueSnackbar]);

  return <>{children}</>;
};

export default ProtectedRoutes;